import { gql } from "@apollo/client";

export const QUERY_TRACK_MAP = gql`
  query getActiveTrackMap {
    getActiveTrackMap {
      circuitName
      configurationName
      circuitID
      configurationID
      trackEdges {
        inner {
          lat
          lon
        }
        outer {
          lat
          lon
        }
      }
      lines {
        name
        lat
        lon
      }
      turnMarkings {
        lat
        lon
        name
      }
      loopMarkings {
        lat
        lon
        name
      }
      attackMarkings {
        lat
        lon
        name
      }
      sectors {
        name
        lat
        lon
      }
    }
  }
`;

export const QUERY_TRACK_MAP_FOR_PREVIEW = gql`
  query getTrackMapForPreview(
    $circuitName: String!
    $circuitID: String!
    $configurationName: String!
    $configurationID: String!
  ) {
    getTrackMapForPreview(
      circuitName: $circuitName
      circuitID: $circuitID
      configurationName: $configurationName
      configurationID: $configurationID
    ) {
      circuitName
      configurationName
      circuitID
      configurationID
      trackEdges {
        inner {
          lat
          lon
        }
        outer {
          lat
          lon
        }
      }
      lines {
        name
        lat
        lon
      }
      turnMarkings {
        lat
        lon
        name
      }
      loopMarkings {
        lat
        lon
        name
      }
      attackMarkings {
        lat
        lon
        name
      }
      sectors {
        name
        lat
        lon
      }
    }
  }
`;

export const QUERY_AVAILABLE_CIRCUITS = gql`
  query getAvailableCircuits {
    getAvailableCircuits {
      fullName
      globalUniqueId
    }
  }
`;

export const QUERY_AVAILABLE_CONFIGURATIONS_FOR_CIRCUIT = gql`
  query getAvailableConfigurationsForCircuit($circuitID: String!) {
    getAvailableConfigurationsForCircuit(globalUniqueId: $circuitID) {
      name
      globalUniqueId
    }
  }
`;

export const MUTATE_SET_ACTIVE_TRACK_MAP = gql`
  mutation setActiveTrackMap(
    $circuitName: String!
    $circuitID: String!
    $configurationName: String!
    $configurationID: String!
  ) {
    setActiveTrackMap(
      circuitName: $circuitName
      circuitID: $circuitID
      configurationName: $configurationName
      configurationID: $configurationID
    )
  }
`;

export const SUBSCRIBE_NEW_ACTIVE_TRACK_MAP = gql`
  subscription newActiveTrackMap {
    newActiveTrackMap {
      circuitName
      configurationName
      circuitID
      configurationID
      trackEdges {
        inner {
          lat
          lon
        }
        outer {
          lat
          lon
        }
      }
      lines {
        name
        lat
        lon
      }
      turnMarkings {
        lat
        lon
        name
      }
      loopMarkings {
        lat
        lon
        name
      }
      attackMarkings {
        lat
        lon
        name
      }
      sectors {
        name
        lat
        lon
      }
    }
  }
`;
